//index.js
import Repository from "../../../repositories/RepositoryFactory";
const ReceiptRepository = Repository.get("receipts");
const DeviceRepository = Repository.get("devices");

export default {
  postReceipt: async ({ commit }, { receipt }) => {
    // console.log(receipt);
    //Please note that if the datatype of the input doesn't match the API and database, it will send null value
    var response = await ReceiptRepository.create(receipt);
    commit("POST_receipt", response.data.result);
  },
  getReceiptTrack: async ({ commit }, { receiptCode }) => {
    var response = await ReceiptRepository.getReceiptTrack(receiptCode);
    commit("SET_receiptTrack", response.data.result);
  },
  getReceipts: async ({ commit }, { lazyParams, searchFilterbyCategory, searchById, searchByString, outletId, isIth, isIpp }) => {
    var response = await ReceiptRepository.getReceipts(lazyParams,searchFilterbyCategory,searchById, searchByString, outletId, isIth, isIpp);
    commit("SET_receipts", response.data.result);
  },
  putCompletionImage: async ({ commit }, { deviceId,completionImage }) => {
    var response = await ReceiptRepository.putCompletionImage(deviceId,completionImage);
    commit("PUT_completionImage", {deviceId:deviceId,result:response.data.result});
  },
  putPostageImage: async ({ commit }, { deviceId,postageImage }) => {
    var response = await ReceiptRepository.putPostageImage(deviceId,postageImage);
    commit("PUT_postageImage", {deviceId:deviceId,result:response.data.result});
  },
  putDeviceIth: async ({ commit }, { deviceId, isIth }) => {
    var response = await ReceiptRepository.putDeviceIth(deviceId, isIth);
    commit("PUT_deviceIth", response.data.result);
  },
  putDeviceIpp: async ({ commit }, { deviceId, isIpp }) => {
    var response = await ReceiptRepository.putDeviceIpp(deviceId, isIpp);
    commit("PUT_deviceIpp", response.data.result);
  },
  postNewProgress: async (
    { commit },
    {
      deviceId,
      name,
      category,
      type,
      newStatusStage,
      maxStatusStage,
      succeed,
      technicalServiceTypeUsedId,
      sparePartPurchasedId,
    }
  ) => {
    var status = {
      deviceId: deviceId,
      name: name,
      category: category,
      type: type,
      newStatusStage: newStatusStage,
      maxStatusStage: maxStatusStage,
      succeed: succeed,
      technicalServiceTypeUsedId: technicalServiceTypeUsedId,
      sparePartPurchasedId: sparePartPurchasedId,
    };
    var response = await DeviceRepository.setTechnicalServiceStatusTimelineNewProgress(
      status
    );
    // The HTTP client resolves (never rejects) both transport errors and success:false bodies,
    // so the caller has to be told explicitly whether the tick was recorded.
    var data = response && response.data;
    if (!data || data.success !== true) {
      var message =
        (data && data.errorMessages && data.errorMessages[0] && data.errorMessages[0].message) ||
        (data && data.errorMessage) ||
        "The status could not be saved. Please refresh and try again.";
      return { success: false, message: message };
    }
    commit("POST_newProgress", {
      completed: data.result,
      status: status,
    });
    return { success: true };
  },
};
